<template>
  <div class="navigation" :class="[{ '--mobile': mainsStore.isMobile }]">
    <template v-for="item in menuList" :key="item.name">
      <button v-if="item.name === 'feedback'" class="navigation__link" @click="togglePopup">
        <span>{{ item.title }}</span>
        <SvgIcon v-if="mainsStore.isMobile" icon="arrow" class="navigation__link-icon" />
      </button>
      <router-link v-else :to="{ name: item.name }" class="navigation__link">
        <span>{{ item.title }}</span>
        <SvgIcon v-if="mainsStore.isMobile" icon="arrow" class="navigation__link-icon" />
      </router-link>
    </template>
    <button class="navigation__exit" @click="logout">
      <span class="navigation__exit-text">Выйти</span>
      <SvgIcon icon="log_out" class="navigation__exit-icon" />
    </button>
    <FeedbackPopup v-if="isOpen" :isOpen="isOpen" @popupClose="togglePopup" />
  </div>
</template>

<script lang="ts" src="./AppNavigation.ts">
</script>

<style lang="scss" src="./AppNavigation.scss"></style>
